import React, { FunctionComponent } from 'react';
import { FormikHelpers, Field } from 'formik';
import { FieldInputProps } from 'formik/dist/types';
import { DatePicker } from '@starjack/shared-components';

type DatePickerProps = {
    label: string;
    className?: string;
    disabled?: boolean;
};

type MaterialDatePickerProps = DatePickerProps & {
    form: FormikHelpers<Date>;
    field: FieldInputProps<Date>;
};

const MaterialDatePicker: FunctionComponent<
    React.PropsWithChildren<MaterialDatePickerProps>
> = ({ field, form, ...props }) => {
    const { name, value } = field;
    const { setFieldValue } = form;
    return (
        <DatePicker
            {...props}
            onChange={(date) => {
                setFieldValue(name, date);
            }}
            value={value}
        />
    );
};

type DatePickerField = {
    name: string;
} & DatePickerProps;

export const DatePickerField: FunctionComponent<
    React.PropsWithChildren<DatePickerField>
> = ({ name, ...props }) => {
    return (
        <Field name={name}>
            {({ field, form }) => (
                <MaterialDatePicker form={form} field={field} {...props} />
            )}
        </Field>
    );
};
